module.exports = __webpack_public_path__ + "img/level1_running_gun.57db1b17.png";